import permissions from './permission-list'

export default [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/product/Products.vue'),
    meta: {
      pageTitle: 'Daftar Produk',
      resource: permissions.product,
      action: 'read',
      navActiveLink: 'products',
      breadcrumb: [
        {
          text: 'Daftar Produk',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/create',
    name: 'products-create',
    component: () => import('@/views/product/create.vue'),
    meta: {
      pageTitle: 'Buat Produk',
      resource: permissions.product,
      action: 'manage',
      navActiveLink: 'products',
      breadcrumb: [
        {
          text: 'Produk',
          active: false,
          to: { path: '/products' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/add-stock',
    name: 'products-add-stock',
    component: () => import('@/views/product/add-stock.vue'),
    meta: {
      pageTitle: 'Stock In/Out',
      resource: permissions.product,
      action: 'manage',
      navActiveLink: 'products',
      breadcrumb: [
        {
          text: 'Produk',
          active: false,
          to: { path: '/products' },
        },
        {
          text: 'Stok Produk',
          active: false,
          to: { path: '/products', query: { tab: 2 } },
        },
        {
          text: 'Ubah',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/:id/edit',
    name: 'products-edit',
    component: () => import('@/views/product/edit.vue'),
    meta: {
      pageTitle: 'Edit Produk',
      resource: permissions.product,
      action: 'manage',
      navActiveLink: 'products',
      breadcrumb: [
        {
          text: 'Produk',
          active: false,
          to: { path: '/products' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/unverified',
    name: 'unverified',
    component: () => import('@/views/unverified/index.vue'),
    meta: {
      pageTitle: 'Daftar Produk Approval',
      resource: permissions.productApproval,
      action: 'read',
      breadcrumb: [
        {
          text: 'Produk Approval',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/switch',
    name: 'products-switch',
    component: () => import('@/views/product/switch.vue'),
    meta: {
      pageTitle: 'Transfer Produk',
      resource: permissions.transferProduct,
      action: 'manage',
      navActiveLink: 'products',
      breadcrumb: [
        {
          text: 'Produk',
          active: false,
          to: { path: '/products' },
        },
        {
          text: 'Transfer Produk',
          active: true,
        },
      ],
    },
  },
]
